import { useMediaQuery } from "@mui/material"

export const spliter = ({ text = "" , limit = 30 , mobileLimit = 20 }) => {
    const finalLimit = useMediaQuery("(max-width:600px)") ? mobileLimit : limit 
    let finalText = text
    if(text?.length > finalLimit){
        finalText = text?.split("").slice(0 , finalLimit).join("") + "..."
    }
    return finalText
}